"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addUserNotice = addUserNotice;
exports.deleteSystemConfig = deleteSystemConfig;
exports.deleteSystemNotice = deleteSystemNotice;
exports.getAdminNoticeConfig = getAdminNoticeConfig;
exports.getAwardConfig = getAwardConfig;
exports.getCompanyExplain = getCompanyExplain;
exports.getCustomService = getCustomService;
exports.getPopWindowMessage = getPopWindowMessage;
exports.getProcedureParamConfig = getProcedureParamConfig;
exports.getProductRisk = getProductRisk;
exports.getSafetyConfig = getSafetyConfig;
exports.getSlideshowList = getSlideshowList;
exports.getSlideshowMessage = getSlideshowMessage;
exports.getSystemBasicList = getSystemBasicList;
exports.getSystemImage = getSystemImage;
exports.getSystemNoticeList = getSystemNoticeList;
exports.getUserNoticeList = getUserNoticeList;
exports.getWithdrawConfig = getWithdrawConfig;
exports.saveSystemConfig = saveSystemConfig;
exports.saveSystemNotice = saveSystemNotice;
exports.updateProductRisk = updateProductRisk;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

// 获取系统公告列表
function getSystemNoticeList(params) {
  return (0, _request.default)({
    url: '/admin/system/message/getSystemNoticeList',
    method: 'get',
    params: params
  });
}

// 删除公告
function deleteSystemNotice(data) {
  return (0, _request.default)({
    url: '/admin/system/message/deleteSystemNotice',
    method: 'post',
    data: data
  });
}

// 保存公告
function saveSystemNotice(data) {
  return (0, _request.default)({
    url: '/admin/system/message/saveSystemNotice',
    method: 'post',
    data: data
  });
}

// 获取系统简介
function getCompanyExplain(params) {
  return (0, _request.default)({
    url: '/admin/system/message/getCompanyExplain',
    method: 'get',
    params: params
  });
}

// 保存系统配置
function saveSystemConfig(data) {
  return (0, _request.default)({
    url: '/admin/system/saveSystemConfig',
    method: 'post',
    data: data
  });
}

// 获取弹窗列表
function getPopWindowMessage(params) {
  return (0, _request.default)({
    url: '/admin/system/message/getPopWindowMessage',
    method: 'get',
    params: params
  });
}

// 删除弹窗
function deleteSystemConfig(data) {
  return (0, _request.default)({
    url: '/admin/system/deleteSystemConfig',
    method: 'post',
    data: data
  });
}

// 获取轮播信息
function getSlideshowMessage(params) {
  return (0, _request.default)({
    url: '/admin/system/message/getSlideshowMessage',
    method: 'get',
    params: params
  });
}

// 获取站内信列表
function getUserNoticeList(params) {
  return (0, _request.default)({
    url: '/admin/system/message/getUserNoticeList',
    method: 'get',
    params: params
  });
}

// 网站信息
function getProcedureParamConfig(params) {
  return (0, _request.default)({
    url: '/admin/system/getProcedureParamConfig',
    method: 'get',
    params: params
  });
}

// 基础配置
function getSystemBasicList(params) {
  return (0, _request.default)({
    url: '/admin/system/getSystemBasicList',
    method: 'get',
    params: params
  });
}

// 获取产品管理-全局控制

function getProductRisk(params) {
  return (0, _request.default)({
    url: '/admin/product/getProductRisk',
    method: 'get',
    params: params
  });
}

// 修改，产品管理-全局控制
function updateProductRisk(data) {
  return (0, _request.default)({
    url: '/admin/product/updateProductRisk',
    method: 'post',
    data: data
  });
}

// 获取系统设置-奖励设置
function getAwardConfig(params) {
  return (0, _request.default)({
    url: '/admin/system/getAwardConfig',
    method: 'get',
    params: params
  });
}

// 获取系统设置-轮播图设置
function getSlideshowList(params) {
  return (0, _request.default)({
    url: '/admin/system/getSlideshowList',
    method: 'get',
    params: params
  });
}

// 获取系统设置-系统图片设置
function getSystemImage(params) {
  return (0, _request.default)({
    url: '/admin/system/getSystemImage',
    method: 'get',
    params: params
  });
}

// 获取系统设置-提现设置
function getWithdrawConfig(params) {
  return (0, _request.default)({
    url: '/admin/system/getWithdrawConfig',
    method: 'get',
    params: params
  });
}

// 获取系统设置-客服设置
function getCustomService(params) {
  return (0, _request.default)({
    url: '/admin/system/getCustomService',
    method: 'get',
    params: params
  });
}

// 获取系统设置-安全设置
function getSafetyConfig(params) {
  return (0, _request.default)({
    url: '/admin/system/getSafetyConfig',
    method: 'get',
    params: params
  });
}

// 获取系统铃声
function getAdminNoticeConfig(params) {
  return (0, _request.default)({
    url: '/admin/system/getAdminNoticeConfig',
    method: 'get',
    params: params
  });
}

// 保存-站内信
function addUserNotice(data) {
  return (0, _request.default)({
    url: '/admin/system/message/addUserNotice',
    method: 'post',
    data: data
  });
}